"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ribbon = void 0;
var $ = require("jquery");
var l = require("lenovo");
var React = require("react");
var translate = l.Translator.translate;
var Ribbon = /** @class */ (function (_super) {
    __extends(Ribbon, _super);
    function Ribbon(props) {
        var _this = _super.call(this, props) || this;
        _this.ChangeProduct = function (e) {
            $('.uil-reload-css span').addClass('reload-animation');
            _this.LoadCaps();
        };
        _this.state = {
            ProductInfo: _this.props.product,
            IsForceCaps: _this.props.IsForceCaps == null ? true : _this.props.IsForceCaps
        };
        if (!_this.state.ProductInfo.IsSucceeded && _this.state.IsForceCaps) {
            _this.LoadCaps();
        }
        return _this;
    }
    Ribbon.prototype.LoadCaps = function () {
        $('.uil-reload-css span').addClass('reload-animation');
        l.LitePageLoader.loadCaps('ContactusStandalone');
    };
    Ribbon.prototype.render = function () {
        var Data = this.state.ProductInfo.Data;
        var icon = "";
        if (Data && Data.SpecialSupport) {
            var special = Data.SpecialSupport.toLowerCase();
            icon = "icon-" + special;
        }
        return (React.createElement("div", { className: "changeProductBox" },
            React.createElement("div", { className: "changeProductImg", id: "changeProductImgHasP" },
                React.createElement("img", { src: this.state.ProductInfo.IsSucceeded ? this.state.ProductInfo.Data.ProductImage : "/msa/contact/images/contactus/warnicon.png" })),
            React.createElement("div", { className: "changeProductTlt", id: "changeProductTltHasP" },
                React.createElement("p", null, translate('view support resources text')),
                React.createElement("h4", { className: icon }, this.state.ProductInfo.IsSucceeded ? this.state.ProductInfo.Data.ProductName : translate(this.state.ProductInfo.Message)),
                React.createElement("a", { className: "change-product-button", onClick: this.ChangeProduct },
                    React.createElement("span", { className: "lenovo-reload" }),
                    this.state.ProductInfo.IsSucceeded ? translate('change product') : translate('select product'))),
            React.createElement("div", { className: "reset" })));
    };
    return Ribbon;
}(React.Component));
exports.Ribbon = Ribbon;
exports.default = Ribbon;
